<mat-drawer-container class="h-full" autosize="false">
  <mat-drawer opened mode="side" position="end" disableClose>
    <div class="h-full bg-white flex flex-col py-6">
      <div class="shrink-0 space-y-2 px-4">
        <div class="flex items-center">
          <div class="flex-auto block font-medium text-sm select-none">Acties</div>
        </div>

        <div
          cdkDropList
          cdkDropListSortingDisabled
        [cdkDropListData]="actionListItems()"
        [cdkDropListDisabled]="isLocked()"
        [cdkDropListConnectedTo]="registeredAccordionIds()"
      >
        @for (actionListItem of actionListItems(); track $index) {
            <div
              cdkDrag
              cdkDragPreviewContainer="parent"
              [cdkDragData]="actionListItem.type"
            >
              <div
                class="flex items-center gap-2 px-3 text-sm rounded-full bg-white font-medium h-8 transition-colors"
                [ngClass]="{
                  'hover:cursor-pointer hover:bg-gray-200 hover:text-gray-800':
                    !isLocked(),
                  'opacity-50 pointer-events-none': isLocked(),
                }"
              >
                <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
                  actionListItem.icon
                }}</mat-icon>

                <span class="flex-auto truncate">{{ actionListItem.value }}</span>
              </div>
            </div>
          }
        </div>
      </div>

      <mat-divider class="my-4! [--mat-divider-color:var(--mat-sidenav-container-divider-color)]" />

      <div class="flex-auto overflow-auto scrollbar-width-thin min-h-0">
        <app-tag-panel [disabled]="isLocked()" />

        <mat-divider class="my-4! [--mat-divider-color:var(--mat-sidenav-container-divider-color)]" />

        <app-variable-panel />
      </div>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <div class="h-full flex flex-col px-4 md:px-6 pt-8 pb-4">
      <div class="flex flex-wrap items-center gap-2 mb-4 min-h-10">
        <div class="flex items-center gap-2">
          <button
            mat-icon-button
            matTooltip="Vorige pagina" 
            type="button"
            (click)="goBack()"
          >
            <mat-icon class="">arrow_back</mat-icon>
          </button>
          <h2 class="text-2xl font-medium" [matTooltip]="dataSource()?.label">
            <span class="w-min max-w-60 truncate block">{{ dataSource()?.label }}</span>
          </h2>

          @if (!isLocked()) {
            <button
              mat-icon-button
              class="inline-flex!"
              matTooltip="Naam wijzigen"
              type="button"
              (click)="handleNameEdit()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          }

          <div class="flex gap-1">
            @if (dataSource()?.version; as version) {
              <span
                class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
              >
                v{{ version }}
              </span>
            }

            @if(currentRoutePath() === 'interactions')
            {
              <span
                class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
              >
                Interactie
              </span>
            } @else {
              <span
                class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
              >
                Template
              </span>
            }

            @if (dataSource()?.status; as status) {
              <span
                class="py-1 px-2 rounded-full text-xs font-medium"
                [ngClass]="{
                  'bg-gray-300 text-gray-800': status === 'draft',
                  'bg-secondary-200 text-secondary-950': status === 'published',
                }"
              >
                {{ status | mapFrom: statusMapping }}
              </span>
            }
          </div>
        </div>

        <div class="ml-auto flex gap-2">
          <button mat-stroked-button type="button" (click)="goToFlowView()">
            <mat-icon>account_tree</mat-icon>
            Bekijk flow
          </button>
          @if (!dataSource()?.isShared) {
            <button
              *appHasPermission="'interaction:publish'"
              [disabled]="
                dataSource()?.status === 'published' ||
                (dataSource()?.questions ?? []).length === 0
              "
              mat-flat-button
              (click)="handleInteractionPublish()"
            >
              Publiceren
            </button>
          }
        </div>
      </div>

      <div class="grid grid-cols-[repeat(2,minmax(375px,1fr))] gap-2 flex-auto">
        <app-question-list [nodes]="dataSourceTree()" [disableControls]="isLocked()" />

        <app-answer-list
          [nodes]="selectedQuestionAnswers()"
          [disableControls]="isLocked()"
          [clientId]="dataSource()?.clientId ?? null"
        />
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
